import { render, staticRenderFns } from "./BookmarksList.vue?vue&type=template&id=68506664"
import script from "./BookmarksList.vue?vue&type=script&lang=js"
export * from "./BookmarksList.vue?vue&type=script&lang=js"
import style0 from "./BookmarksList.vue?vue&type=style&index=0&id=68506664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports